module.exports = __webpack_public_path__ + "img/stripe_logo.359b0f65.jpg";